import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule, DatePipe, DecimalPipe} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {
    AccordionModule, AlertModule, BsDatepickerModule, BsDropdownModule, ButtonsModule, CarouselModule, CollapseModule,
    DatepickerModule, ModalModule, PaginationModule, PopoverModule, ProgressbarModule, RatingModule, TabsModule,
    TimepickerModule,
    TooltipModule, TypeaheadModule
} from "ngx-bootstrap";
import {ToasterModule} from "angular2-toaster";
import {ColorsService} from "./colors/colors.service";
import {FlotDirective} from "./directives/flot/flot.directive";
import {SparklineDirective} from "./directives/sparkline/sparkline.directive";
import {EasypiechartDirective} from "./directives/easypiechart/easypiechart.directive";
import {CheckallDirective} from "./directives/checkall/checkall.directive";
import {VectormapDirective} from "./directives/vectormap/vectormap.directive";
import {NowDirective} from "./directives/now/now.directive";
import {ScrollableDirective} from "./directives/scrollable/scrollable.directive";
import {JqcloudDirective} from "./directives/jqcloud/jqcloud.directive";
import {RouterModule} from "@angular/router";
import {ngxLoadingAnimationTypes, NgxLoadingModule} from "ngx-loading";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        AccordionModule.forRoot(),
        AlertModule.forRoot(),
        ButtonsModule.forRoot(),
        CarouselModule.forRoot(),
        CollapseModule.forRoot(),
        DatepickerModule.forRoot(),
        BsDatepickerModule.forRoot(),
        BsDropdownModule.forRoot(),
        ModalModule.forRoot(),
        PaginationModule.forRoot(),
        ProgressbarModule.forRoot(),
        RatingModule.forRoot(),
        TabsModule.forRoot(),
        TimepickerModule.forRoot(),
        TooltipModule.forRoot(),
        PopoverModule.forRoot(),
        TypeaheadModule.forRoot(),
        NgxLoadingModule.forRoot({animationType: ngxLoadingAnimationTypes.cubeGrid}),
        ToasterModule
    ],
    providers: [
        ColorsService,
        DecimalPipe,
        DatePipe
    ],
    declarations: [
        FlotDirective,
        SparklineDirective,
        EasypiechartDirective,
        CheckallDirective,
        VectormapDirective,
        NowDirective,
        ScrollableDirective,
        JqcloudDirective
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        RouterModule,
        AccordionModule,
        AlertModule,
        ButtonsModule,
        CarouselModule,
        CollapseModule,
        DatepickerModule,
        BsDatepickerModule,
        BsDropdownModule,
        ModalModule,
        PaginationModule,
        ProgressbarModule,
        RatingModule,
        TabsModule,
        TimepickerModule,
        TooltipModule,
        PopoverModule,
        TypeaheadModule,
        ToasterModule,
        FlotDirective,
        SparklineDirective,
        EasypiechartDirective,
        CheckallDirective,
        VectormapDirective,
        NowDirective,
        ScrollableDirective,
        JqcloudDirective,
        NgxLoadingModule,
    ]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule
        };
    }
}
